import { render, staticRenderFns } from "./tag-search-append.vue?vue&type=template&id=457ddb56&"
import script from "./tag-search-append.vue?vue&type=script&lang=ts&"
export * from "./tag-search-append.vue?vue&type=script&lang=ts&"
import style0 from "./tag-search-append.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports